export enum ReferralType {
	Reinsurance
}